/* eslint-disable @typescript-eslint/no-explicit-any */
/* global window, document */

import './polyfills';

import '@search/vtbeco-frontend-core/domain/boot/ssr/script/sentry-fixes';
import 'intersection-observer';

import React from 'react';
import ReactDOM from 'react-dom';
import { GqlClient } from '@search/gql-client/src';
import { gqlBrowserClient } from '@search/gql-client/src/GqlBrowserClient';
import { clGeoRootRegionRepositoryLoad } from '@search/geo/src/clGeoRootRegion/clGeoRootRegionRepositoryLoad';
import * as Sentry from '@sentry/browser';
import { getDefaultOptions } from '@vtblife/sentry';
import { configureUnhandledErrorsNotification } from '@vtblife/layout-components';
import getEnvironmentByHost from '@search/common-core/src/get-environment-by-host';
import { Router } from '@search/router/src';
import { RouterContext } from '@search/offer-search-routes/src';
import { AppState } from '@search/vtbeco-frontend-core/domain/offer/search/types/AppState';
import { GoogleOptimizeConfig } from '@search/vtbeco-frontend-core/domain/google/useGoogleOptimize';

import { pkgName } from '../view/pkgName';
import { App } from '../view/App';

const config = (window as any)[`${pkgName}_config`] || {};
const state: AppState = (window as any)[`${pkgName}_state`];

if (typeof Sentry !== 'undefined') {
    Sentry.init(getDefaultOptions({
        allowUrls: undefined,
        dsn: process.env.SENTRY_DSN,
        release: process.env.SENTRY_RELEASE,
        environment: getEnvironmentByHost(window.location.host),
        // @ts-ignore
        enabled: window.IS_DEBUG !== 'true'
    }));

    configureUnhandledErrorsNotification();
}

const googleOptimize = config.googleOptimize as GoogleOptimizeConfig;

const gql = new GqlClient({
    client: gqlBrowserClient({
        path: config.graphqlPath,
        headerAppName: 'search'
    }),
    // @ts-ignore
    cache: state
});

async function init() {
    const rootRegions = await clGeoRootRegionRepositoryLoad({ gql });

    const router = new Router<RouterContext>({
        context: {
            isMobile: false,
            rootRegions,
            preferRelativeUrl: true
        },
        // @ts-ignore
        location: window.locationMock ?? window.location,
        target: window,
        history: window.history
    });

    ReactDOM.hydrate(
        <App
            rootRegions={rootRegions}
            googleOptimize={googleOptimize}
            gql={gql}
            auth={state.auth}
            router={router}
            yMapsApiKey={config.yMapsApiKey}
            staticPath={config.staticPath}
            catcher={{
                logError({ error, displayName }) {
                    Sentry?.withScope(scope => {
                        scope.setExtras({ displayName });
                        Sentry?.captureException(error);
                    });
                }
            }}
            developerPromoConfigs={config.developerPromoConfigs}
        />,
        document.getElementById(pkgName)
    );
}

// eslint-disable-next-line @typescript-eslint/no-floating-promises
init();

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
// @ts-ignore
if (typeof module.hot === 'object') {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    module.hot.accept();
}
